module.exports = __webpack_public_path__ + "static/media/solr.d858d9fe.webp";